import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { chartDataUrl: String }

  connect() {
    this.waitForCapacityManagement((cm) => this.setup(cm))
  }

  waitForCapacityManagement(done, attempts = 0) {
    const cm = window.App?.CapacityManagement
    if (cm) {
      done(cm)
      return
    }
    if (attempts < 100) {
      requestAnimationFrame(() => this.waitForCapacityManagement(done, attempts + 1))
    }
  }

  async setup(cm) {
    cm.bindForCharts()
    await this.fetchAndDraw(cm)
  }

  async fetchAndDraw(cm) {
    const url = this.chartDataUrlValue + window.location.search
    try {
      const res = await fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      })
      if (!res.ok) return
      const data = await res.json()
      cm.drawCharts(data)
    } catch (_e) {
      return
    }
  }
}
